import { render } from "./Dashboard.vue?vue&type=template&id=d7f8e02a&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=d7f8e02a&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/pins/pinsv2/Pins_Queuing_System/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7f8e02a"]])

export default __exports__